// @ts-nocheck
import React from "react";

export interface StepFromInputContextData {
    currentStep: number;
    editable: boolean;
    hasSubmitted: boolean;
}
const StepFormInputContext = React.createContext<StepFromInputContextData | undefined>(undefined);

export const useStepFormInputContext = () => {
    const context = React.useContext(StepFormInputContext);
    if (!context) {
        throw new Error("useStepFormInputContext must be used within a StepFormInputContext");
    }
    return context;
};

export default StepFormInputContext;
